// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__zC03E","small":"style_small__1hN2S","icon":"style_icon__35cgw"};